import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "../../hooks/useForm";
import backArrowIcon from "../../assets/img/back-arrow.png";
import "../../assets/css/common.css";
import { useAuth } from "../../routers/AuthProvider";
import InvoiceDetails from "../../components/InvoiceDetails";
import AsyncSelect from "react-select/async";
import { API_URL } from "../../utils/constant";
import { useReactToPrint } from "react-to-print";
import Receipt from "../../components/Receipt";
import axios from "axios";
import moment from "moment";
import { truncateDecimal } from "../../utils/truncateDecimal";
import WholesaleOrderTable from "../../components/WholesaleOrderTable";
import WholesalePromotionTable from "../../components/WholesalePromotionTable";
import PointChangePopup from "../../components/PointChangePopup";
import Popup from "../../components/Popup";
import { Toast } from "../../components/ToastComponent";

export default function CreateWholesaleOrder() {
  const backPath = `/sale/wholesale-order/list`;
  const { handleInputChange, formData, submitForm, setError, error } =
    useForm();

  useEffect(() => {
    if (error) {
      Toast.fire({
        title: error,
        icon: "error",
      });
    }
  }, [error]);

  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0];

  const { user, setLoading } = useAuth();
  const [saleProducts, setSaleProducts] = useState([]);
  const [currencyType, setCurrencyType] = useState("MMK");
  const [total, setTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [taxEnabled, setTaxEnabled] = useState(0);
  const [tax, setTax] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [change, setChange] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [saleDate, setSaleDate] = useState(today);
  const [paidAmount, setPaidAmount] = useState(0);
  const [loyaltyPoint, setLoyaltyPoint] = useState(0);
  const [memberCode, setMemberCode] = useState("");
  const [voucherCode, setVoucherCode] = useState("");
  const [remark, setRemark] = useState();
  const isInitialMount = useRef(true);
  const [customer, setCustomer] = useState(null);
  const [mmkTotal, setMmkTotal] = useState(0);
  const [thbTotal, setThbTotal] = useState(0);
  const [activeTab, setActiveTab] = useState();
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState("");

  const [totalInMMK, setTotalInMMK] = useState(0);
  const [totalInTHB, setTotalInTHB] = useState(0);
  const [subTotalMMK, setSubTotalMMK] = useState(0);
  const [subTotalTHB, setSubTotalTHB] = useState(0);
  const [advancedInMMK, setAdvancedInMMK] = useState(0);
  const [advancedInTHB, setAdvancedInTHB] = useState(0);
  const [advancedEnabled, setAdvancedEnabled] = useState(0);
  const [taxAmountInMMK, setTaxAmountInMMK] = useState(0);
  const [taxAmountInTHB, setTaxAmountInTHB] = useState(0);
  const [changeInMMK, setChangeInMMK] = useState(0);
  const [changeInTHB, setChangeInTHB] = useState(0);
  const [promotionProducts, setPromotionProducts] = useState([]);
  const [discountInMMK, setDiscountInMMK] = useState(0);
  const [discountInTHB, setDiscountInTHB] = useState(0);
  const [paidAmountInMMK, setPaidAmountInMMK] = useState(0);
  const [paidAmountInTHB, setPaidAmountInTHB] = useState(0);
  const [promotionAmount, setPromotionAmount] = useState(0);
  const [promotionAmountInMMK, setPromotionAmountInMMK] = useState(0);
  const [promotionAmountInTHB, setPromotionAmountInTHB] = useState(0);
  const [promotionByTotal, setPromotionByTotal] = useState({
    promotion: {},
    applyPromo: false,
  });
  const [promotions, setPromotions] = useState([]);
  const [currentPromotions, setCurrentPromotions] = useState();
  const currentDate = new Date();

  const [popup, setPopup] = useState({
    show: false,
    id: "",
    eID: "",
  });

  useEffect(() => {
    document
      .getElementById("external-popup")
      .classList.toggle("show", popup.show);
  }, [popup.show]);

  const onClosePopup = (e) => {
    e.preventDefault();
    setPopup({
      id: "",
      show: false,
    });
  };

  useEffect(() => {
    let mmkInit = 0;
    let thbInit = 0;
    setMmkTotal(mmkInit);
    setThbTotal(thbInit);
    saleProducts.map((product) => {
      if (currencyType === "MMK") {
        mmkInit = mmkInit + Number(product.mmkTotal);
        setMmkTotal(mmkInit);
      } else {
        thbInit = thbInit + Number(product.thbTotal);
        setThbTotal(thbInit);
      }
    });
  }, [saleProducts, currencyType]);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!customer?.customer_id) {
      setError("Valid member code is required!");
      return;
    }

    if (!selectedWarehouseId) {
      setError("Warehouse is required!");
      return;
    }

    setLoading(true);
    const items = getSaleItems(saleProducts);
    const data = {
      items,
      sale_date: saleDate,
      wholesale_customer_id: customer?.customer_id ?? 0,
      promotion_method:
        promotionByTotal.applyPromo && promotionByTotal.promotion
          ? "AMOUNT"
          : "",
      promotion_amount: promotionAmount,
      remark,
      currency_type: currencyType,
      sub_total: subTotal,
      discount,
      tax,
      tax_amount: taxAmount,
      paid_amount: paidAmount,
      change,
      total,
      status: "ACTIVE",
      loyalty: loyaltyPoint,
      rate: exchangeRate,
      mmk_total: mmkTotal,
      thb_total: thbTotal,

      discount_mmk: discountInMMK,
      discount_thb: discountInTHB,
      sub_total_mmk: subTotalMMK,
      sub_total_thb: subTotalTHB,
      promotion_amount_mmk: promotionAmountInMMK,
      promotion_amount_thb: promotionAmountInTHB,
      tax_mmk: taxAmountInMMK,
      tax_thb: taxAmountInTHB,
      advanced_mmk: advancedInMMK,
      advanced_thb: advancedInTHB,
      paid_amount_mmk: paidAmountInMMK,
      paid_amount_thb: paidAmountInTHB,
      change_mmk: changeInMMK,
      change_thb: changeInTHB,
      total_mmk: totalInMMK,
      total_thb: totalInTHB,
      warehouse_id: selectedWarehouseId,
      advanced_enabled: advancedEnabled,
      loyalty_amount: loyaltyRule ? loyaltyRule.amount : 0,
    };

    submitForm("POST", "/wholesale", data, (response) => {
      setVoucherCode(response.data.voucher_code);
    });
  };

  //   useEffect(() => {
  //         if (isInitialMount.current) {
  //             isInitialMount.current = false;
  //         } else {
  //             handlePrint();
  //         }
  //     }, [voucherCode])

  useEffect(() => {
    if (promotionByTotal.promotion) {
      let tempPromoAmt =
        parseFloat(promotionAmount) +
          parseFloat(promotionByTotal?.promotion?.promotion_amount) ?? 0;
      //console.log("promo: ", promotionByTotal?.promotion?.promotion_amount);
      //console.log("discount: ", parseFloat(promotionAmount));
      //console.log("TempDis: ", tempPromoAmt);
      setPromotionAmount(tempPromoAmt);
    }
  }, [promotionByTotal]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      handlePrint();
    }
  }, [voucherCode]);

  // const getSaleItems = (products) => {
  //     const result = products.map(product => ({
  //         product_id: product.product_id,
  //         barcode: product.barcode,
  //         quantity: product.quantity,
  //         price: currencyType === "MMK" ? product.mmkPrice : product.thbPrice,
  //         sub_total: currencyType === "MMK" ? product.mmkTotal : product.thbTotal,
  //         total: currencyType === "MMK" ? product.mmkTotal : product.mmkTotal
  //     }));
  //     return result;
  // }

  const getSaleItems = (products) => {
    let promoItems = [];
    const crossProductRewardItems = [];
    const processedCrossPromoIds = new Set();
    const result = products.map((product) => {
      let a;
      a = {
        product_id: product.product_id,
        product_name: product.product_name,
        barcode: product.barcode,
        sku_unit_id: product.sku_unit_id,
        quantity: product.quantity,
        price: currencyType === "MMK" ? product.mmkPrice : product.thbPrice,
        sub_total: currencyType === "MMK" ? product.mmkTotal : product.thbTotal,
        total: currencyType === "MMK" ? product.mmkTotal : product.thbTotal,
      };

      if (product.applyPromo && product.promotion) {
        if (product.promotion_type === "By Percent") {
          a.promotion_type = "PERCENT";
          a.promotion_id = resolvePromotionId(product.promotion, [
            "promotion_by_percent_id",
            "promotion_id",
            "id",
          ]);
          a.promotion_amount =
            (product.promotion.percent_amount / 100) * a.sub_total;
          a.total =
            a.sub_total -
            (product.promotion.percent_amount / 100) * a.sub_total;
        } else if (product.promotion_type === "By BOGO") {
          a.promotion_type = "BOGO";
          a.promotion_id = resolvePromotionId(product.promotion, [
            "promotion_by_bogo_id",
            "promotion_id",
            "id",
          ]);
          a.promotion_amount = 0;
          a.quantity = a.quantity;
          promoItems.push({
            barcode: product.barcode,
            product_name: product.product_name,
            quantity: product.quantity,
          });
        } else if (product.promotion_type === "By Cross Product") {
          a.promotion_type = "CROSS_PRODUCT";
          a.promotion_id = resolvePromotionId(product.promotion, [
            "promotion_by_cp_id",
            "promotion_id",
            "id",
          ]);
          a.promotion_amount = 0;
          // let crossable_qty = 0;
          // product.promotion.crossableProducts.map(crossProduct => {
          //     crossProduct.quantity
          // });

          // product.promotion.promoProducts.map(promoProduct => {
          //     // floor(total/crossable_qty) * promo_qty

          //     promoItems.push({ product_name: promoProduct.product.product_name, quantity: Math.floor(crossable_qty) * promoProduct.quantity })
          // });
          const eligibleTimes = Number(product.promotion?.eligibleTimes) || 0;
          product.promotion.promoProducts.map((promoProduct) => {
            promoItems.push({
              product_name: promoProduct.product.product_name,
              quantity: eligibleTimes * promoProduct.quantity,
            });
          });

          const crossPromoId = a.promotion_id;
          if (!processedCrossPromoIds.has(crossPromoId)) {
            processedCrossPromoIds.add(crossPromoId);

            product.promotion.promoProducts.forEach((promoProduct) => {
              crossProductRewardItems.push({
                product_id: promoProduct.product_id,
                product_name: promoProduct.product?.product_name,
                barcode:
                  promoProduct.barcode ?? promoProduct.product?.barcode ?? "",
                sku_unit_id: promoProduct.product?.sku_unit_id,
                quantity: eligibleTimes * (Number(promoProduct.quantity) || 0),
                price: 0,
                sub_total: 0,
                total: 0,
                promotion_type: "CROSS_PRODUCT",
                promotion_id: crossPromoId,
                promotion_amount: 0,
              });
            });
          }
        }
      }
      setPromotionProducts(promoItems);
      return a;
    });
    return result.concat(
      crossProductRewardItems.filter((item) => item.quantity > 0)
    );
  };

  const getPrintItems = (products) => {
    const result = products.map((product) => ({
      description: product.product_name,
      quantity: product.quantity,
      price: currencyType === "MMK" ? product.mmkPrice : product.thbPrice,
      total: currencyType === "MMK" ? product.mmkTotal : product.thbTotal,
      barcode: product.barcode,
    }));
    return result;
  };

  const loadOptions = (inputValue) => {
    return axios
      .get(API_URL + "/product?status=ACTIVE", {
        withCredentials: true,
      })
      .then((response) => {
        return response.data.data.filter((option) =>
          option.product_name.toLowerCase().includes(inputValue.toLowerCase())
        );
      });
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [errorBarcodeMessage, setErrorBarcodeMessage] = useState("");
  const [errorMemberMessage, setErrorMemberMessage] = useState("");
  const [exchangeRate, setExchangeRate] = useState();
  const [reverseExchangeRate, setReverseExchangeRate] = useState();

  const findMatchingCrossPromotion = (productId) => {
    return currentPromotions?.find((promo) => {
      if (promo.promotion_type !== "By Cross Product") {
        return false;
      }

      return (promo.crossableProducts ?? []).some(
        (crossableProduct) =>
          isSameProductId(crossableProduct.product_id, productId)
      );
    });
  };

  useEffect(() => {
    axios
      .get(API_URL + "/currencyExchange?limit=1&page=1&sort=-created_date", {
        withCredentials: true,
      })
      .then((response) => {
        setExchangeRate(response.data.data[0].exchange_rate);
        setReverseExchangeRate(response.data.data[0].reverse_exchange_rate);
      });
  }, []);

  useEffect(() => {
    axios
      .get(API_URL + "/warehouse?status=ACTIVE", {
        withCredentials: true,
      })
      .then((response) => {
        setWarehouses(response.data.data || []);
      });
  }, []);

  useEffect(() => {
    if (taxEnabled) {
      setTaxAmount(parseFloat(((tax / 100) * subTotal).toFixed(2)));
    } else {
      setTaxAmount(0);
    }
  }, [tax, subTotal, currencyType, taxEnabled]);

  useEffect(() => {
    setTotal((subTotal + taxAmount - discount).toFixed(2));
  }, [subTotal, discount, taxAmount, currencyType]);

  useEffect(() => {
    if (subTotal >= loyaltyRule?.amount) {
      setLoyaltyPoint(loyaltyRule?.point);
    }
  }, [subTotal]);

  useEffect(() => {
    if (taxEnabled && currencyType === "SEPERATED") {
      setTaxAmountInMMK(parseFloat(((tax / 100) * subTotalMMK).toFixed(2)));
    } else {
      setTaxAmountInMMK(0);
    }
  }, [tax, subTotalMMK, taxEnabled]);

  useEffect(() => {
    if (taxEnabled && currencyType === "SEPERATED") {
      setTaxAmountInTHB(parseFloat(((tax / 100) * subTotalTHB).toFixed(2)));
    } else {
      setTaxAmountInTHB(0);
    }
  }, [tax, subTotalTHB, taxEnabled]);

  useEffect(() => {
    if (!currentPromotions?.length) {
      return;
    }

    setSaleProducts((prevData) =>
      prevData.map((product) => {
        if (
          product.promotion_type !== "By Cross Product" ||
          product.promotion ||
          product.crossPromotionDetail
        ) {
          return product;
        }

        const crossPromotionDetail = findMatchingCrossPromotion(
          product.product_id
        );

        return crossPromotionDetail
          ? { ...product, crossPromotionDetail }
          : product;
      })
    );
  }, [currentPromotions]);

  useEffect(() => {
    const subTotalVal = parseFloat(subTotal) || 0;
    const taxAmountVal = parseFloat(taxAmount) || 0;
    const discountVal = parseFloat(discount) || 0;
    const promotionAmountVal = parseFloat(promotionAmount) || 0;
    const advancedInMMKVal = parseFloat(advancedInMMK) || 0;
    const advancedInTHBVal = parseFloat(advancedInTHB) || 0;
    let totalValue =
      subTotalVal + taxAmountVal - discountVal - promotionAmountVal;

    if (advancedEnabled && currencyType === "MMK") {
      totalValue -= advancedInMMKVal;
    } else if (advancedEnabled && currencyType === "BAHT") {
      totalValue -= advancedInTHBVal;
    }
    setTotal(truncateDecimal(totalValue, 5));
  }, [
    subTotal,
    discount,
    taxAmount,
    promotionAmount,
    advancedEnabled,
    advancedInMMK,
    advancedInTHB,
  ]);

  useEffect(() => {
    if (subTotal >= loyaltyRule?.amount) {
      setLoyaltyPoint(loyaltyRule?.point);
    }
    if (subTotalMMK >= loyaltyRule?.amount) {
      setLoyaltyPoint(loyaltyRule?.point);
    }
    if (subTotalTHB >= loyaltyRule?.amount) {
      setLoyaltyPoint(loyaltyRule?.point);
    }
    setPromotionByTotal({ applyPromo: promotionByTotal.applyPromo });
    setSaleProducts((prevData) => {
      return prevData.map((product) => ({ ...product, promotion: null }));
    });

    // console.log("Current Promotion",currentPromotions)

    currentPromotions?.forEach((promo) => {
      if (promo.promotion_type === "By Total") {
        //console.log("Minimum Total Amount",promo.minimum_total_amount)
        // console.log("Sub total",subTotal)
        console.log("Promo Currency", promo.currency_type);
        console.log("Currency type", currencyType);
        if (promo.currency_type === currencyType) {
          if (subTotal > promo.minimum_total_amount) {
            setPromotionByTotal({
              promotion: promo,
              applyPromo: promotionByTotal.applyPromo,
            });
          }
        }
      } else if (promo.promotion_type === "By Percent") {
        if (
          saleProducts.some(
            (product) => isSameProductId(product.product_id, promo.product_id)
          )
        ) {
          setSaleProducts((prevData) => {
            return prevData.map((product) =>
              isSameProductId(product.product_id, promo.product_id)
                ? {
                    ...product,
                    applyPromo: product.applyPromo,
                    promotion: { ...promo, eligibleTimes: product.quantity },
                  }
                : product
            );
          });
        }
      } else if (promo.promotion_type === "By BOGO") {
        if (
          saleProducts.some(
            (product) => isSameProductId(product.product_id, promo.product_id)
          )
        ) {
          setSaleProducts((prevData) => {
            return prevData.map((product) =>
              isSameProductId(product.product_id, promo.product_id)
                ? {
                    ...product,
                    applyPromo: product.applyPromo,
                    promotion: { ...promo, eligibleTimes: product.quantity },
                  }
                : product
            );
          });
        }
      } else {
        const crossableProducts = promo.crossableProducts.map(
          (crossableProduct) => crossableProduct.product_id
        );
        let crossable = true;
        crossableProducts.forEach((crossableProduct) => {
          if (
            !saleProducts.some(
              (product) => isSameProductId(product.product_id, crossableProduct)
            )
          ) {
            crossable = false;
          }
        });

        if (crossable) {
          const m = [];

          promo.crossableProducts.forEach((crossableProduct) => {
            const quantity = saleProducts.find(
              (product) =>
                isSameProductId(product.product_id, crossableProduct.product_id)
            ).quantity;
            m.push(Math.floor(quantity / crossableProduct.quantity));
          });

          const l = Math.min(...m);

          if (l === 0) {
            return;
          }

          promo.crossableProducts.forEach((crossableProduct) => {
            setSaleProducts((prevData) => {
              return prevData.map((product) =>
                isSameProductId(product.product_id, crossableProduct.product_id)
                  ? {
                      ...product,
                      applyPromo: product.applyPromo,
                      promotion: { ...promo, eligibleTimes: l },
                    }
                  : product
              );
            });
          });
        }
      }
    });
  }, [currentPromotions, subTotal, currencyType, subTotalMMK, subTotalTHB]);

  useEffect(() => {
    const subTotalMMKVal = parseFloat(subTotalMMK) || 0;
    const taxAmountInMMKVal = parseFloat(taxAmountInMMK) || 0;
    const discountInMMKVal = parseFloat(discountInMMK) || 0;
    const promotionAmountInMMKVal = parseFloat(promotionAmountInMMK) || 0;
    const advancedInMMKVal = parseFloat(advancedInMMK) || 0;
    let totalValue =
      subTotalMMKVal +
      taxAmountInMMKVal -
      discountInMMKVal -
      promotionAmountInMMKVal;
    if (advancedEnabled) {
      totalValue -= advancedInMMKVal;
    }
    setTotalInMMK(truncateDecimal(totalValue, 5));
  }, [
    subTotalMMK,
    discountInMMK,
    ,
    taxAmountInMMK,
    promotionAmountInMMK,
    advancedInMMK,
    advancedEnabled,
  ]);

  useEffect(() => {
    const subTotalTHBVal = parseFloat(subTotalTHB) || 0;
    const taxAmountInTHBVal = parseFloat(taxAmountInTHB) || 0;
    const discountInTHBVal = parseFloat(discountInTHB) || 0;
    const promotionAmountInTHBVal = parseFloat(promotionAmountInTHB) || 0;
    const advancedInTHBVal = parseFloat(advancedInTHB) || 0;
    let totalValue =
      subTotalTHBVal +
      taxAmountInTHBVal -
      discountInTHBVal -
      promotionAmountInTHBVal;
    if (advancedEnabled) {
      totalValue -= advancedInTHBVal;
    }
    setTotalInTHB(truncateDecimal(totalValue, 5));
  }, [
    subTotalTHB,
    discountInTHB,
    ,
    taxAmountInTHB,
    promotionAmountInTHB,
    advancedInTHB,
    advancedEnabled,
  ]);

  useEffect(() => {
    const paidAmountVal = parseFloat(paidAmount) || 0;
    const totalVal = parseFloat(total) || 0;
    let changeValue = paidAmountVal - totalVal;
    setChange(truncateDecimal(changeValue, 5));
  }, [paidAmount, total]);

  useEffect(() => {
    const totalInMMKVal = parseFloat(totalInMMK) || 0;
    const paidAmountInMMKVal = parseFloat(paidAmountInMMK) || 0;
    let changeInMMK = paidAmountInMMKVal - totalInMMKVal;
    setChangeInMMK(truncateDecimal(changeInMMK, 5));
  }, [paidAmountInMMK, totalInMMK]);

  useEffect(() => {
    const totalInTHBVal = parseFloat(totalInTHB) || 0;
    const paidAmountInTHBVal = parseFloat(paidAmountInTHB) || 0;
    let changeInTHB = paidAmountInTHBVal - totalInTHBVal;
    setChangeInTHB(truncateDecimal(changeInTHB, 5));
  }, [paidAmountInTHB, totalInTHB]);

  const printRef = useRef();
  const pageStyle = `
    @media print {
        @page {
        size: 70mm 250mm;
        margin: 0 0.3in 0 0;
        }

        html, body {
            height: auto;
            font-size: 12pt; /* changing to 10pt has no impact */
        }
    }`;

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => navigate(backPath),
    pageStyle: pageStyle,
  });

  const barcodeRef = useRef(null);
  useEffect(() => {
    barcodeRef.current.focus();
  }, []);

  const [loyaltyRule, setLoyaltyRule] = useState();

  useEffect(() => {
    axios
      .get(API_URL + "/promotion", {
        withCredentials: true,
      })
      .then((response) => {
        setPromotions(response.data.data);
      });

    axios
      .get(
        API_URL +
          `/loyalty?status=ACTIVE&loyalty_type=wholesale&sort=-created_date`,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        if (response.data.data.length) {
          const res = response.data.data[0];
          const startDate = moment(
            res.start_date,
            "YYYY-MM-DD HH:mm:ss"
          ).startOf("day");
          const endDate = moment(res.end_date, "YYYY-MM-DD HH:mm:ss").endOf(
            "day"
          );
          const now = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
          if (now > startDate && now < endDate) {
            setLoyaltyRule(res);
          }
        }
      });

    document.querySelector(".side-nav").style.display = "none";
    document.querySelector(".sub-layout").style.paddingLeft = "0px";
  }, []);

  useEffect(() => {
    const filteredData = [];
    const promoTypes = ["amount", "percent", "bogo", "cross_product"];

    promoTypes.forEach((promoType) => {
      promotions?.[promoType]?.filter((item) => {
        if (item.status !== "ACTIVE") {
          return;
        }

        const startDate = new Date(item.start_date);
        const endDate = new Date(item.end_date);

        if (currentDate >= startDate && currentDate <= endDate) {
          filteredData.push(item);
        }
      });
    });

    setCurrentPromotions(filteredData);
  }, [promotions]);
  console.log("sale product", saleProducts);
  return (
    <div className="sub-page-layout-1">
      <Link className="back-to-page" to={backPath}>
        <img src={backArrowIcon} />
        Back
      </Link>
      <div className="container" style={{ height: "auto" }}>
        <h1 className="sub-page-title">Create New Wholesale Order</h1>
        <div className="form-container">
          <form className="form flex flex-col justify-between w-full">
            <div className="grid grid-cols-2 gap-9">
              {/* <div className='grow'>
                                <label className='x-label input-required'>Product Name</label>
                                <AsyncSelect
                                    defaultOptions
                                    cacheOptions
                                    loadOptions={loadOptions}
                                    isSearchable={true}
                                    isMulti={true}
                                    getOptionLabel={option => option.product_name}
                                    getOptionValue={option => option.product_id}
                                    value={saleProducts}
                                    onChange={option => {
                                        const newObj = option.map(item => {
                                            const mmkPrice = item.mmkPrice ? item.mmkPrice : convertCurrency(item, "MMK", exchangeRate, reverseExchangeRate)
                                            const thbPrice = item.thbPrice ? item.thbPrice : convertCurrency(item, "BAHT", exchangeRate, reverseExchangeRate)
                                            const quantity = item.quantity ? item.quantity : 1
                                            const mmkTotal = item.mmkTotal ? item.mmkTotal : mmkPrice
                                            const thbTotal = item.thbTotal ? item.thbTotal : thbPrice
                                            return { ...item, quantity, mmkPrice, thbPrice, mmkTotal, thbTotal }
                                        })
                                        setSaleProducts(newObj)
                                    }}
                                    styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            borderColor: '#1b1b1b66',
                                            minHeight: '50px'
                                        }),
                                    }}
                                />
                            </div> */}
              <div className="grow">
                <label className="x-label">Barcode</label>
                <input
                  type="text"
                  tabIndex={1}
                  ref={barcodeRef}
                  name="barcode"
                  //pattern="[0-9]+"
                  pattern="^[0-9]+$"
                  inputMode="numeric"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                  onChange={(e) => {
                    // Show message if non-numeric character is present
                    if (/[^0-9]/.test(e.target.value)) {
                      setErrorBarcodeMessage("Only numbers are allowed.");
                    } else {
                      setErrorBarcodeMessage(""); // Clear message when input is valid
                    }
                  }}
                  onKeyDown={(e) => {
                    // e.target.nextElementSibling.classList.remove('block')
                    // e.target.nextElementSibling.classList.add('hidden')
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const url =
                        API_URL +
                        `/wholesale/productDetail?barcode=${e.target.value}`;
                      // if (saleProducts.some(item => item.barcode === e.target.value)) {
                      //     e.target.value = ""
                      //     return;
                      // }
                      axios
                        .get(url, {
                          withCredentials: true,
                        })
                        .then((response) => {
                          e.target.value = "";
                          if (
                            !response?.data?.data ||
                            response.data.data.length === 0
                          ) {
                            e.target.nextElementSibling.classList.remove(
                              "hidden"
                            );
                            e.target.nextElementSibling.classList.add("block");
                          } else {
                            if (
                              response.data.data &&
                              response.data.data.length > 0
                            ) {
                              const newItem = response.data.data[0];
                              const normalizedItem = {
                                ...newItem,
                                retail_price: newItem.wholesale_price,
                                crossPromotionDetail:
                                  newItem.crossPromotionDetail ??
                                  (newItem.promotion_type ===
                                  "By Cross Product"
                                    ? findMatchingCrossPromotion(
                                        newItem.product_id
                                      )
                                    : undefined),
                              };
                              const existing = saleProducts.filter(
                                (v) => v.barcode == normalizedItem.barcode
                              );
                              setCurrencyType(normalizedItem.currency);
                              //const thbPrice = item.thbPrice ? item.thbPrice : convertCurrency(item, "BAHT", exchangeRate, reverseExchangeRate)
                              //console.log("existing", existing)

                              if (existing.length) {
                                setSaleProducts((prevData) => {
                                  return prevData.map((product) => {
                                    if (
                                      product.product_id !==
                                      existing[0].product_id
                                    )
                                      return product;

                                    const newQty =
                                      parseInt(product.quantity) + 1;

                                    const mmkPrice =
                                      product.mmkPrice ??
                                      convertCurrency(
                                        product,
                                        "MMK",
                                        exchangeRate,
                                        reverseExchangeRate
                                      );

                                    const thbPrice =
                                      product.thbPrice ??
                                      convertCurrency(
                                        product,
                                        "BAHT",
                                        exchangeRate,
                                        reverseExchangeRate
                                      );

                                    const mmkTotal = newQty * mmkPrice;
                                    const thbTotal = newQty * thbPrice;

                                    const convertedMMKTotal = mmkTotal;
                                    const convertedTHBTotal = thbTotal;

                                    return {
                                      ...product,
                                      crossPromotionDetail:
                                        product.crossPromotionDetail ??
                                        normalizedItem.crossPromotionDetail,
                                      quantity: newQty,
                                      mmkPrice,
                                      thbPrice,
                                      mmkTotal,
                                      thbTotal,
                                      convertedMMKTotal,
                                      convertedTHBTotal,
                                    };
                                  });
                                });
                              } else {
                                // setErrorMessage("Product Not Found");
                                const mmkPrice =
                                  normalizedItem.mmkPrice ??
                                  convertCurrency(
                                    normalizedItem,
                                    "MMK",
                                    exchangeRate,
                                    reverseExchangeRate
                                  );
                                const thbPrice =
                                  normalizedItem.thbPrice ??
                                  convertCurrency(
                                    normalizedItem,
                                    "BAHT",
                                    exchangeRate,
                                    reverseExchangeRate
                                  );
                                const quantity = 1;
                                const mmkTotal = quantity * mmkPrice;
                                const thbTotal = quantity * thbPrice;

                                const convertedMMKTotal =
                                  normalizedItem.currency === "MMK"
                                    ? mmkTotal
                                    : convertCurrency(
                                        {
                                          ...normalizedItem,
                                          retail_price: thbPrice,
                                        },
                                        "MMK",
                                        exchangeRate,
                                        reverseExchangeRate
                                      );

                                const convertedTHBTotal =
                                  normalizedItem.currency === "BAHT"
                                    ? thbTotal
                                    : convertCurrency(
                                        {
                                          ...normalizedItem,
                                          retail_price: mmkPrice,
                                        },
                                        "BAHT",
                                        exchangeRate,
                                        reverseExchangeRate
                                      );

                                const newProduct = {
                                  ...normalizedItem,
                                  quantity,
                                  mmkPrice,
                                  thbPrice,
                                  mmkTotal,
                                  thbTotal,
                                  convertedMMKTotal,
                                  convertedTHBTotal,
                                };

                                setSaleProducts((prev) => [
                                  ...prev,
                                  newProduct,
                                ]);
                              }
                            } else {
                              setErrorMessage("Product Not Found");
                            }
                          }
                        });
                    }
                  }}
                  className="x-input"
                />
                {errorBarcodeMessage && (
                  <div className="text-red-500 text-sm mt-1">
                    {errorBarcodeMessage}
                  </div>
                )}
                {/* <span className='hidden text-red-500'>Product Not Found</span> */}
              </div>
              <div className="grow">
                <label className="x-label input-required">Sale Date</label>
                <input
                  type="date"
                  required
                  name="sale_date"
                  value={saleDate}
                  onChange={(e) => setSaleDate(e.target.value)}
                  className="x-input"
                />
              </div>
              <div className="grow">
                <label className="x-label input-required">Warehouse</label>
                <div className="dd-container">
                  <select
                    required
                    value={selectedWarehouseId}
                    onChange={(e) => setSelectedWarehouseId(e.target.value)}
                    className="x-input dropdown"
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    {warehouses.map((warehouse) => (
                      <option
                        key={warehouse.warehouse_id}
                        value={warehouse.warehouse_id}
                      >
                        {warehouse.warehouse_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="grow">
                <label className="x-label input-required">
                  Member Code{" "}
                  {memberCode !== "" && customer?.customer_name
                    ? `(${customer.customer_name} - ${customer.loyalty_points} points)`
                    : ""}
                </label>
                <input
                  type="text"
                  name="member_code"
                  className="x-input"
                  required
                  //pattern="[0-9]+"
                  pattern="^[0-9]+$"
                  inputMode="numeric"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                  onChange={(e) => {
                    // Show message if non-numeric character is present
                    if (/[^0-9]/.test(e.target.value)) {
                      setErrorMemberMessage("Only numbers are allowed.");
                    } else {
                      setErrorMemberMessage(""); // Clear message when input is valid
                    }
                  }}
                  onKeyDown={(e) => {
                    // e.target.nextElementSibling.classList.remove('block')
                    // e.target.nextElementSibling.classList.add('hidden')
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const url =
                        API_URL +
                        `/wholesale/wholesaleCustomer?member_code=${e.target.value}`;
                      if (
                        saleProducts.some(
                          (item) => item.barcode === e.target.value
                        )
                      ) {
                        e.target.value = "";
                        e.target.nextElementSibling.classList.remove("hidden");
                        e.target.nextElementSibling.classList.add("block");
                        setCustomer(null);
                        setMemberCode("");
                        return;
                      }
                      axios
                        .get(url, {
                          withCredentials: true,
                        })
                        .then((response) => {
                          if (
                            !response?.data?.data ||
                            response.data.data.length === 0
                          ) {
                            e.target.value = "";
                            e.target.nextElementSibling.classList.remove(
                              "hidden"
                            );
                            e.target.nextElementSibling.classList.add("block");
                            setCustomer(null);
                            setMemberCode("");
                          } else {
                            const customerData = response?.data?.data?.[0];
                            if (!customerData) {
                              e.target.value = "";
                              setCustomer(null);
                              setMemberCode("");
                            } else {
                              setCustomer(customerData);
                              setAdvancedInMMK(customerData?.advanced_mmk);
                              setAdvancedInTHB(customerData?.advanced_thb);
                              setMemberCode(customerData?.member_code ?? "");
                            }
                          }
                        });
                    }
                  }}
                />
                {errorMemberMessage && (
                  <div className="text-red-500 text-sm mt-1">
                    {errorMemberMessage}
                  </div>
                )}
                {/* <span className='hidden text-red-500'>Member Card Not Found</span> */}
              </div>
              <div className="grow">
                <label className="x-label">Remark</label>
                <input
                  type="text"
                  name="remark"
                  onChange={(e) => {
                    const value = e.target.value;
                    setRemark(value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      return;
                    }
                  }}
                  className="x-input"
                />
              </div>
            </div>
            {customer && (
              <div className="flex flex-row-reverse mt-6">
                <button
                  className="gold-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    setPopup({ id: 0, eID: "changePoint", show: true });
                  }}
                >
                  Change Advance
                </button>
              </div>
            )}
            {/* <WholesaleOrderTable
                            data={saleProducts}
                            currencyType={currencyType}
                            THBToMMK={exchangeRate}
                            MMKToTHB={reverseExchangeRate}
                            setSubTotal={setSubTotal}
                            setSaleProducts={setSaleProducts}
                            setSubTotalMMK={setSubTotalMMK}
                            setSubTotalTHB={setSubTotalTHB}
                            promotionByTotal={promotionByTotal} 
                            setPromotionByTotal={setPromotionByTotal}
                        /> */}

            <WholesaleOrderTable
              data={saleProducts}
              currentPromotions={currentPromotions}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              promotionByTotal={promotionByTotal}
              setPromotionByTotal={setPromotionByTotal}
              currencyType={currencyType}
              THBToMMK={exchangeRate}
              MMKToTHB={reverseExchangeRate}
              setSubTotal={setSubTotal}
              setSubTotalMMK={setSubTotalMMK}
              setSubTotalTHB={setSubTotalTHB}
              setSaleProducts={setSaleProducts}
            />

            <WholesalePromotionTable
              saleProducts={saleProducts}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              currencyType={currencyType}
              promotionByTotal={promotionByTotal}
              setPromotionAmount={setPromotionAmount}
            />
            <div className="py-12 flex flex-row-reverse justify-around">
              <div className="grow-[0.2]">
                {/* <InvoiceDetails
                                    total={total}
                                    currencyType={currencyType}
                                    setCurrencyType={setCurrencyType}
                                    subTotal={subTotal}
                                    taxEnabled={taxEnabled}
                                    setTaxEnabled={setTaxEnabled}
                                    tax={tax} setTax={setTax}
                                    taxAmount={taxAmount}
                                    change={change}
                                    discount={discount}
                                    setDiscount={setDiscount}
                                    paidAmount={paidAmount}
                                    setPaidAmount={setPaidAmount}

                                    totalInMMK={totalInMMK}
                                    totalInTHB={totalInTHB}
                                    advancedEnabled={advancedEnabled}
                                    setAdvancedEnabled={setAdvancedEnabled}
                                    discountInMMK={discountInMMK}
                                    discountInTHB={discountInTHB}
                                    setDiscountInMMK={setDiscountInMMK}
                                    setDiscountInTHB={setDiscountInTHB}
                                    subTotalMMK={subTotalMMK}
                                    subTotalTHB={subTotalTHB}
                                    changeInTHB={changeInTHB}
                                    changeInMMK={changeInMMK}
                                    advancedInMMK={advancedInMMK}
                                    advancedInTHB={advancedInTHB}
                                    setAdvancedInMMK={setAdvancedInMMK}
                                    setAdvancedInTHB={setAdvancedInTHB}
                                    taxAmountInMMK={taxAmountInMMK}
                                    taxAmountInTHB={taxAmountInTHB}
                                    paidAmountInMMK={paidAmountInMMK}
                                    paidAmountInTHB={paidAmountInTHB}
                                    setPaidAmountInMMK={setPaidAmountInMMK}
                                    setPaidAmountInTHB={setPaidAmountInTHB}
                                /> */}
                <InvoiceDetails
                  total={total}
                  totalInMMK={totalInMMK}
                  totalInTHB={totalInTHB}
                  currencyType={currencyType}
                  setCurrencyType={setCurrencyType}
                  subTotal={subTotal}
                  taxEnabled={taxEnabled}
                  setTaxEnabled={setTaxEnabled}
                  advancedEnabled={advancedEnabled}
                  setAdvancedEnabled={setAdvancedEnabled}
                  tax={tax}
                  setTax={setTax}
                  taxAmount={taxAmount}
                  change={change}
                  discount={discount}
                  setDiscount={setDiscount}
                  discountInMMK={discountInMMK}
                  discountInTHB={discountInTHB}
                  setDiscountInMMK={setDiscountInMMK}
                  setDiscountInTHB={setDiscountInTHB}
                  paidAmount={paidAmount}
                  setPaidAmount={setPaidAmount}
                  promotionAmount={promotionAmount}
                  promotionAmountInMMK={promotionAmountInMMK}
                  promotionAmountInTHB={promotionAmountInTHB}
                  subTotalMMK={subTotalMMK}
                  subTotalTHB={subTotalTHB}
                  changeInTHB={changeInTHB}
                  changeInMMK={changeInMMK}
                  advancedInMMK={advancedInMMK}
                  advancedInTHB={advancedInTHB}
                  setAdvancedInMMK={setAdvancedInMMK}
                  setAdvancedInTHB={setAdvancedInTHB}
                  taxAmountInMMK={taxAmountInMMK}
                  taxAmountInTHB={taxAmountInTHB}
                  paidAmountInMMK={paidAmountInMMK}
                  paidAmountInTHB={paidAmountInTHB}
                  setPaidAmountInMMK={setPaidAmountInMMK}
                  setPaidAmountInTHB={setPaidAmountInTHB}
                />
              </div>
            </div>
            <Receipt
              mmkTotal={mmkTotal}
              thbTotal={thbTotal}
              total={total}
              discount={discount}
              subTotal={subTotal}
              voucherCode={voucherCode}
              currencyType={currencyType}
              THBToMMK={exchangeRate}
              MMKToTHB={reverseExchangeRate}
              paidAmount={paidAmount}
              change={change}
              getPrintItems={getPrintItems}
              saleProducts={saleProducts}
              printRef={printRef}
              exchangeRate={exchangeRate}
              reverseExchangeRate={reverseExchangeRate}
              changeInMMK={changeInMMK}
              changeInTHB={changeInTHB}
              discountInMMK={discountInMMK}
              discountInTHB={discountInTHB}
              paidAmountInMMK={paidAmountInMMK}
              paidAmountInTHB={paidAmountInTHB}
              totalInMMK={totalInMMK}
              totalInTHB={totalInTHB}
            />
            <div className="form-btn-group">
              {error ? (
                <span className="w-full block text-lg text-red-500 text-right">
                  {error}
                </span>
              ) : (
                ""
              )}
              <div className="flex justify-end gap-5 mt-5">
                <Link to={backPath} className="white-btn">
                  Cancel
                </Link>
                <button className="gold-btn" onClick={onSubmit} tabIndex={4}>
                  Create
                </button>
              </div>
            </div>
          </form>
        </div>
        <Popup className="popup-container">
          {popup.eID === "changePoint" && customer && (
            <PointChangePopup
              data={customer}
              onCloseClick={onClosePopup}
              modelName="WholesaleCustomer"
              callback={(res) => {
                // console.log("res:",res)
                if (res) {
                  setAdvancedInMMK(res?.advanced_mmk);
                  setAdvancedInTHB(res?.advanced_thb);
                }
                setPopup({
                  id: "",
                  show: false,
                });
              }}
            />
          )}
        </Popup>
      </div>
    </div>
  );
}

const convertCurrency = (product, currencyType, THBToMMK, MMKToTHB) => {
  let convertedPrice;

  console.log("Currency Retrieve:", product.currency);

  if (currencyType === product.currency) {
    convertedPrice = product.wholesale_price;
  } else {
    if (product.currency === "MMK") {
      convertedPrice = product.wholesale_price * MMKToTHB;
    } else {
      convertedPrice = nearValue(product.wholesale_price / THBToMMK);
    }
  }
  return convertedPrice;
};

function nearValue(input) {
  const output = Math.ceil(input / 100) * 100;
  return output;
}

function resolvePromotionId(promotion, keys) {
  for (const key of keys) {
    const value = promotion?.[key];
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }
  return undefined;
}

function isSameProductId(left, right) {
  return String(left) === String(right);
}
